<template>
  <div
    v-if="
      entry.id &&
        entry.weekdays &&
        !(isUsingDefaultWeekdays && hideDefaultWeekdays)
    "
  >
    <small class="msr--text nowrap">{{ description }}</small>
  </div>
</template>

<script>
import {describeWeekdays, equalsDefaultWeekdays} from '@/mixins/weekdays';

export default {
  props: {
    entry: {
      type: Object,
      required: true,
    },
    hideDefaultWeekdays: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    isUsingDefaultWeekdays() {
      return equalsDefaultWeekdays(this.entry.weekdays);
    },
    description() {
      return describeWeekdays(this.entry.weekdays);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/EntryWeekdays.vue